'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel, TransitionChild } from '@headlessui/react';
import { ModalBackdrop } from '@src/components/Modal/ModalBackdrop';
import { TopNavV6AccountPanelContent } from '@src/components/TopNavV6/TopNavV6AccountPanel/TopNavV6AccountPanelContent';
import { useTopNavV6 } from '@src/components/TopNavV6/TopNavV6Context';
import { useHasMounted } from '@src/hooks/useHasMounted';
import { cn } from '@src/utils/tailwind';
export const TopNavV6AccountPanel = () => {
  const $ = _c(7);
  const {
    isAccountExpanded,
    setAccountExpanded
  } = useTopNavV6();
  const hasMounted = useHasMounted();
  const t0 = isAccountExpanded && hasMounted;
  let t1;
  if ($[0] !== setAccountExpanded) {
    t1 = () => setAccountExpanded(false);
    $[0] = setAccountExpanded;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ModalBackdrop className="hidden backdrop-blur-sm lg:block" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="fixed inset-0 flex justify-end overflow-y-auto"><TransitionChild><DialogPanel className={cn("size-full max-w-full lg:w-[420px]", "duration-200 ease-out data-closed:translate-x-full")}><TopNavV6AccountPanelContent /></DialogPanel></TransitionChild></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t0 || $[5] !== t1) {
    t4 = <Dialog transition={true} open={t0} onClose={t1} className="relative z-max transition duration-200 ease-out">{t2}{t3}</Dialog>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};